<template>
    <Modal>
        <div class="pt-6">
            <h2
                class="text-brand-neutral-7 text-base font-bold text-center mb-4"
            >
                Escolha o que você precisa
            </h2>
            <p class="text-brand-neutral-5 text-sm text-center">
                Aumente seu faturamento atingindo mais clientes e melhorando a
                experiência deles.
            </p>
        </div>
        <div class="flex mt-6">
            <TabButton
                title="Mensal"
                :active="selectedTab === 'monthly'"
                @click="selectedTab = 'monthly'"
            />
            <TabButton
                title="Anual"
                :active="selectedTab === 'yearly'"
                @click="selectedTab = 'yearly'"
            />
        </div>
        <div class="flex flex-col gap-6 py-4 px-4">
            <SubscriptionPlanCard
                v-for="plan in plans"
                :key="plan._id"
                :title="plan.name"
                :price="plan.price"
                :features="plan.features"
                :ctaTitle="plan.active ? 'Ativo' : 'Assinar'"
                :discountPercentage="plan.discountPercentage"
                :featured="plan.featured"
                icon="/icons/subscriptions/free.svg"
                @click="onSubscribePlan(plan)"
            />
        </div>
    </Modal>
</template>
<script setup lang="ts">
type Tab = "monthly" | "yearly";

interface IActivePlan {
    _id: string;
    name: string;
    price: number;
    discountPercentage?: string;
    featured?: boolean;
    features: string[];
    interval: Tab;
    active: boolean;
}

const totalPlans: IPlan[] = await useApi("/plans");
const subscription: ISubscription = await useApi("/subscriptions/active");
const selectedTab = ref<Tab>("yearly");

const route = useRoute();
const { $api } = useNuxtApp();
const redirectTo = route.params.redirectTo as string | undefined;

const onSubscribePlan = async (plan: IActivePlan) => {
    try {
        const checkoutRes = await $api(
            "/payments/stripe/create-subscription-checkout-session",
            {
                method: "POST",
                body: {
                    planId: plan._id,
                    interval: plan.interval,
                },
            }
        );

        await navigateTo(
            `/account/checkout?clientSecret=${checkoutRes.clientSecret}${
                redirectTo ? `&redirectTo=${redirectTo}` : ""
            }`
        );
    } catch (error) {
        /**
         * @todo Log error to sentry
         */
        console.error(error);
    }
};

const plans = computed<IActivePlan[]>(() => {
    return totalPlans
        .filter((plan) => !plan.free)
        .map((plan) => {
            const price =
                plan.prices.find(
                    (price) =>
                        price.interval === selectedTab.value &&
                        price.currency === "brl"
                )?.price! / (selectedTab.value === "yearly" ? 12 : 1);
            let discountPercentage = undefined;

            if (selectedTab.value === "yearly") {
                const monthlyPrice = plan.prices.find(
                    (price) =>
                        price.interval === "monthly" && price.currency === "brl"
                )!.price;

                discountPercentage = (
                    ((monthlyPrice - price) / monthlyPrice) *
                    100
                ).toFixed();
            }

            return {
                _id: plan._id,
                name: plan.name[UserLanguages.PT_BR],
                price,
                discountPercentage,
                features: plan.features.map(
                    (feature) => feature[UserLanguages.PT_BR]
                ),
                featured: plan.featured && price > subscription.price,
                active: subscription?.plan._id === plan._id,
                interval: selectedTab.value,
            };
        });
});
</script>
